/* Shared carousel for every ENR section. Any element with [data-enr-carousel]
   containing [data-enr-track] gets dots, arrows and snap sync.
   Add [data-enr-loop] as well and it wraps around endlessly, so there is
   always a card peeking at both edges. */
(function () {
  function play(button) {
    var media = button.parentNode.querySelector('video');
    if (!media) return;
    if (media.paused) {
      media.play();
      media.setAttribute('controls', '');
      button.style.display = 'none';
    }
  }

  function bindPlay(scope) {
    (scope || document).querySelectorAll('[data-enr-play]').forEach(function (b) {
      if (b.dataset.enrBound === '1') return;
      b.dataset.enrBound = '1';
      b.addEventListener('click', function () { play(b); });
    });
  }

  function init(root) {
    if (root.dataset.enrInit === '1') return;
    var track = root.querySelector('[data-enr-track]');
    if (!track) return;
    root.dataset.enrInit = '1';

    var real = Array.prototype.slice.call(track.children);
    var loop = root.hasAttribute('data-enr-loop') && real.length > 1;

    /* Loop mode: three copies of the strip, the real one in the middle. When a
       scroll settles inside a clone set we shift by exactly one set width, which
       lands on an identical snap position and is therefore invisible. */
    if (loop) {
      var lead = document.createDocumentFragment();
      var trail = document.createDocumentFragment();
      real.forEach(function (item) {
        var a = item.cloneNode(true);
        var b = item.cloneNode(true);
        a.setAttribute('aria-hidden', 'true');
        b.setAttribute('aria-hidden', 'true');
        a.dataset.enrClone = '1';
        b.dataset.enrClone = '1';
        lead.appendChild(a);
        trail.appendChild(b);
      });
      track.appendChild(trail);
      track.insertBefore(lead, track.firstChild);
      bindPlay(track);
    }

    var items = Array.prototype.slice.call(track.children);
    var n = real.length;
    var offset = loop ? n : 0;

    var dotsWrap = root.querySelector('[data-enr-dots]');
    var prev = root.querySelector('[data-enr-prev]');
    var next = root.querySelector('[data-enr-next]');
    var dots = [];
    var settle = null;
    var settleLoop = null;

    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      real.forEach(function (item, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'enr-dot';
        b.setAttribute('aria-label', 'Slide ' + (i + 1));
        b.addEventListener('click', function () { go(i + offset); });
        dotsWrap.appendChild(b);
        dots.push(b);
      });
      if (n < 2) dotsWrap.style.display = 'none';
    }

    function centered() { return root.classList.contains('enr-car--center'); }

    function padLeft() {
      return parseFloat(window.getComputedStyle(track).paddingLeft) || 0;
    }

    /* Anchor line inside the viewport that a slide should line up with. */
    function anchor() {
      var tr = track.getBoundingClientRect();
      return centered() ? tr.left + tr.width / 2 : tr.left + padLeft();
    }

    /* Where a slide currently sits, measured the same way. */
    function point(item) {
      var ir = item.getBoundingClientRect();
      return centered() ? ir.left + ir.width / 2 : ir.left;
    }

    function setWidth() {
      if (!loop) return 0;
      return items[offset + n].offsetLeft - items[offset].offsetLeft;
    }

    function current() {
      var a = anchor();
      var best = 0;
      var bestDist = Infinity;
      items.forEach(function (item, i) {
        var d = Math.abs(point(item) - a);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }

    /* Silently pull the scroll position back into the middle set. */
    function normalize() {
      if (!loop) return;
      var w = setWidth();
      if (!w) return;
      var i = current();
      if (i >= offset && i < offset + n) return;
      var was = track.style.scrollSnapType;
      track.style.scrollSnapType = 'none';
      track.scrollLeft += i < offset ? w : -w;
      track.style.scrollSnapType = was;
    }

    /* Mandatory scroll snap cancels programmatic smooth scrolling, so lift it
       for the duration. The timeout also lands the scroll outright when the
       animation was throttled (background tab, reduced motion). */
    function glide(to) {
      var max = track.scrollWidth - track.clientWidth;
      to = Math.max(0, Math.min(max, to));

      track.style.scrollSnapType = 'none';
      track.scrollTo({ left: to, behavior: 'smooth' });

      window.clearTimeout(settle);
      settle = window.setTimeout(function () {
        if (Math.abs(track.scrollLeft - to) > 2) track.scrollLeft = to;
        track.style.scrollSnapType = '';
        normalize();
        sync();
      }, 520);
    }

    function go(i) {
      var item = items[i];
      if (!item) return;
      glide(track.scrollLeft + (point(item) - anchor()));
    }

    function sync() {
      var i = current();
      var active = loop ? ((i - offset) % n + n) % n : i;
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === active); });
      if (loop) {
        if (prev) prev.disabled = false;
        if (next) next.disabled = false;
        return;
      }
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
    }

    if (prev) prev.addEventListener('click', function () {
      var i = current() - 1;
      go(loop ? i : Math.max(0, i));
    });
    if (next) next.addEventListener('click', function () {
      var i = current() + 1;
      go(loop ? i : Math.min(items.length - 1, i));
    });

    var raf = null;
    track.addEventListener('scroll', function () {
      if (!raf) {
        raf = window.requestAnimationFrame(function () { raf = null; sync(); });
      }
      if (loop) {
        window.clearTimeout(settleLoop);
        settleLoop = window.setTimeout(function () { normalize(); sync(); }, 140);
      }
    }, { passive: true });

    function rest() {
      if (!loop) { sync(); return; }
      var was = track.style.scrollSnapType;
      track.style.scrollSnapType = 'none';
      track.scrollLeft += point(items[offset]) - anchor();
      track.style.scrollSnapType = was;
      sync();
    }

    window.addEventListener('resize', function () { sync(); });

    var host = root.closest('details');
    if (host) host.addEventListener('toggle', function () { window.setTimeout(rest, 60); });

    root.__enrGo = function (i) { go(i + offset); };
    root.__enrItems = real;

    window.requestAnimationFrame(rest);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { window.requestAnimationFrame(rest); });
    }
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-enr-carousel]').forEach(init);
    bindPlay(scope);
  }

  document.addEventListener('DOMContentLoaded', function () { boot(); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    boot();
    var root = e.target.closest('[data-enr-carousel]');
    if (root && root.__enrGo) {
      var i = root.__enrItems.indexOf(e.target);
      if (i < 0) {
        var parent = e.target.closest('[data-enr-track] > *');
        if (parent) i = root.__enrItems.indexOf(parent);
      }
      if (i >= 0) root.__enrGo(i);
    }
  });
  boot();
})();
